<template>
  <BaseNoticeItem info>
    <template #head>
      <strong>{{ $t('PAYE bills must be inside contract period') }}</strong>
    </template>
    <template #body>
      {{
        $t(
          'Please make sure that the entered billing period is inside your contract period (:start_date - :end_date).',
          {
            // eslint-disable-next-line vue/camelcase -- Baseline eslint ignore please fix if working on this
            start_date: dateStart,
            // eslint-disable-next-line vue/camelcase -- Baseline eslint ignore please fix if working on this
            end_date: dateEnd,
          },
        )
      }}
      <strong>{{ $t('Otherwise you cannot be paid for this bill.') }}</strong>
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import gql from 'graphql-tag'
import moment from 'moment'
import { computed } from 'vue'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import { useTranslation } from '@/composables/translation'

const props = defineProps({
  complianceData: {
    type: Object,
    required: true,
  },
  hire: {
    type: Object,
    required: true,
  },
  isComplete: {
    type: Boolean,
    required: true,
  },
})

const { $t } = useTranslation()

const dateStart = computed(() => {
  const { dateStart: date } = props.hire
  if (date === null) {
    return null
  }
  return moment(date).format('YYYY-MM-DD')
})

const dateEnd = computed(() => {
  const { dateEnd: date } = props.hire
  if (date === null) {
    return null
  }
  return moment(date).format('YYYY-MM-DD')
})
</script>

<script>
export const fragments = {
  hire: gql`
    fragment PayeContractPeriodNoticeHire on Hire {
      dateStart
      dateEnd
    }
  `,
}
</script>
